import type {TurnState} from '@wandb/weave/lib/WbAgent/WbAgentClient';

export const AGENT_CHAT_DRAWER_WIDTH = 400;

export const STATE_COLORS: Record<TurnState, string> = {
  queued: '#13A9BA',
  in_progress: '#F5A822',
  completed: '#00B26E',
  errored: '#FF596D',
  cancelled: '#8F949E',
};

/** Shared left-indent for message body content (below avatar row). */
export const MSG_INDENT_PL = 'pl-[27px]';
